import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

// Harborlight source design system: Bootstrap 5 + icons + the ported source
// stylesheet (client/src/styles/app.css). Loaded after Tailwind so the ported
// Bootstrap-based screens render exactly as in the approved source UI.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@/styles/harborlight.css';

import Root from '../Root';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <StrictMode>
    <Root />
  </StrictMode>
);
